// Todo: cleanup and format this file

// libs
import React, { lazy, ReactElement, Suspense } from "react";

// components
import { Loader } from "@swiggy-private/dls-web-core/dist/components/Loader";

// styles
import { LoadingContainer } from "@dineout-cart-client/components/table-reservation/styles";

// internal libs
import { RouterProps, Router, RouteProps } from "@swiggy-private/core-ui";
import { PaymentRoutes } from "@swiggy-private/payment-client";
import { CheckoutRoute, DineoutCheckoutRouteContainer } from "@swiggy-private/checkout-core";
import { DineoutCheckoutRoute } from "@swiggy-private/checkout-core";

// components
import TableReservationCart from "@dineout-cart-client/components/table-reservation/TableReservationCartWrapper";
import { DineoutCartMain } from "@dineout-cart-client/components/dineout-cart-main/DineoutCartMain";
import { CouponListing } from "@dineout-cart-client/components/coupon-listing";
import { BillPaymentCartRenderer } from "@dineout-cart-client/components/bill-payment-renderer";
import { DineoutPaymentExternalRoutes } from "@dineout-cart-client/components/payment-external-routes";
import { ScenesFullPayment } from "@dineout-cart-client/components/scenes-full-payment";
import { StealStoreCartRenderer } from "../steal-store-renderer";

export type CheckoutRouterProps = Omit<RouterProps<DineoutCheckoutRoute>, "children">;

const OUT_IN_ROUTES: DineoutCheckoutRoute[] = [
    DineoutCheckoutRoute.CONFIRM_ORDER,
    DineoutCheckoutRoute.PAYMENT_TXN_STATUS_POLLING,
];

const DineCashPoolingPage = lazy(
    () =>
        import(
            /* webpackChunkName: "dine_cash_pooling" */
            "@dineout-cart-client/components/dine-cash-pooling/DineCashPoolingPage"
        ),
);

const DineCashPoolingFallback = (
    <LoadingContainer>
        <Loader size="large" type="secondary" foregroundColor="positive" backgroundColor="positive_Sub" isDisabled={false} />
    </LoadingContainer>
);

// Wrapper carries the `name` prop so buildRoutes registers it correctly with parent = CART
const DineCashPoolingRoute = (props: RouteProps<DineoutCheckoutRoute>) => (
    <Suspense fallback={DineCashPoolingFallback}>
        <DineCashPoolingPage {...props} />
    </Suspense>
);

const CartRoutes = [
    <DineoutCartMain
        name={DineoutCheckoutRoute.CART}
        key={DineoutCheckoutRoute.CART}
        indexElement={
            <BillPaymentCartRenderer
                name={DineoutCheckoutRoute.BILL_PAYMENT_CART}
                key={DineoutCheckoutRoute.BILL_PAYMENT_CART}
            />
        }
    >
        <BillPaymentCartRenderer
            name={DineoutCheckoutRoute.BILL_PAYMENT_CART}
            key={DineoutCheckoutRoute.BILL_PAYMENT_CART}
        />
        <TableReservationCart
            name={DineoutCheckoutRoute.TABLE_RESERVATION_CART}
            key={DineoutCheckoutRoute.TABLE_RESERVATION_CART}
        />
        <ScenesFullPayment
            name={DineoutCheckoutRoute.SCENES_FULL_PAYMENT}
            key={DineoutCheckoutRoute.SCENES_FULL_PAYMENT}
        />
        <StealStoreCartRenderer
            name={DineoutCheckoutRoute.STEAL_STORE_CART}
            key={DineoutCheckoutRoute.STEAL_STORE_CART}
        />
        <CouponListing name={DineoutCheckoutRoute.COUPON_LISTING} key={CheckoutRoute.COUPON_LISTING} />
        <DineCashPoolingRoute
            name={DineoutCheckoutRoute.DINE_CASH_POOLING}
            key={DineoutCheckoutRoute.DINE_CASH_POOLING}
        />
    </DineoutCartMain>,
];

export function CheckoutRouter(props: CheckoutRouterProps): ReactElement {
    const routes = [...PaymentRoutes, ...DineoutPaymentExternalRoutes];
    routes.push(...CartRoutes);
    return (
        <Router {...props} container={DineoutCheckoutRouteContainer} nonOverlappingTransitionRoutes={OUT_IN_ROUTES}>
            {routes}
        </Router>
    );
}
